import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import React from 'react';
import i18n from 'i18next';
import { Modal, message, Button, Form, Radio, Input } from 'antd';
import { Row, Col, Select } from 'antd';
import { apis } from '../api/index.js';
import { getInstitutionOptions, passwordBuilder } from '../utils';
import { institutionRecord } from '../utils';
const { TextArea } = Input;
const { Option } = Select;

class UserAdd extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    userDetail: PropTypes.object,
    form: PropTypes.object,
    userTypeList: PropTypes.array,
    roleInfoRecordList: PropTypes.array,
    history: PropTypes.object,
    type: PropTypes.string,
  };

  state = {
    confirmLoading: false,
    userDetail: {},
    status: 0,
    userTypeList: [],
    disabled: false,
    institutionData: [],
  };
  componentDidUpdate(prevProps) {
    const { visible } = this.props;
    if (prevProps.visible !== visible && visible) {
      this.props.form.resetFields();
      this.getInstitutionData();
      const { userDetail } = this.props;
      let disabled;
      if (userDetail.id) disabled = true;
      else disabled = false;
      this.setState({ disabled, userDetail, type: this.props.type });
    }
    if (prevProps.userDetail.id !== this.props.userDetail.id) {
      this.setState({ userDetail: this.props.userDetail });
    }
  }

  //获取机构列表
  getInstitutionData = async name => {
    const data = await institutionRecord(name);
    this.setState({ institutionData: data });
  };

  handleOk = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const userId = this.state.userDetail.id;
        if (userId) this.updateUser(values, userId);
        else this.addUser(values);
      }
    });
  };

  //新增用户
  addUser = values => {
    const post = {
      accountName: values.account,
      nickName: values.name,
      status: values.status,
      boxUserType: values.type,
      institutionId: values.institution,
      roleId: values.role,
      mobile: values.contact,
      remark: values.remark,
      password: values.password,
      certId: values.certId,
    };
    apis.addBoxUser(post).then(res => {
      if (res.code === '0') {
        message.success('添加成功');
        this.handleCancel(true);
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //修改用户
  updateUser = (values, userId) => {
    const post = {
      id: userId,
      nickName: values.name,
      status: values.status,
      boxUserType: values.type,
      institutionId: values.institution,
      roleId: values.role,
      mobile: values.contact,
      remark: values.remark,
      certId: values.certId,
      email: values.email,
    };
    apis.modifyBoxUser(post).then(res => {
      if (res.code === '0') {
        message.success('修改成功');
        this.handleCancel(true);
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = changed => {
    this.props.onCancel(changed);
  };

  handlePassword = () => {
    const password = passwordBuilder(6);
    this.props.form.setFieldsValue({ password });
  };

  render() {
    const { confirmLoading, disabled } = this.state;
    const { userDetail, institutionData, type } = this.state;
    const { userTypeList, roleInfoRecordList, visible } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = { labelCol: { span: 6 }, wrapperCol: { span: 18 } };
    const formItemLayout1 = { labelCol: { span: 3 }, wrapperCol: { span: 21 } };
    let title = '';
    if (userDetail.id) title = 'updateUser';
    else title = 'newUser';
    return (
      <div className="group-modal">
        <Modal
          title={i18n.t(title)}
          visible={visible}
          width={'50%'}
          height={'60%'}
          className="group-manager"
          onCancel={this.handleCancel}
          footer={[
            <Button
              key="cancel"
              onClick={this.handleCancel}
              type="default"
              className="btn-cancel"
            >
              {i18n.t('cancel')}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={confirmLoading}
              onClick={this.handleOk}
              className="btn-ok"
            >
              {i18n.t('ok')}
            </Button>,
          ]}
        >
          <div className="user-add-form">
            <Form {...formItemLayout}>
              <Row gutter={15}>
                <Col span={12}>
                  {/* 用户姓名 */}
                  <Form.Item label={i18n.t('username')} hasFeedback>
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: '用户姓名不能为空' }],
                      initialValue: userDetail.nickName,
                    })(<Input type="text" />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 登录账号 */}
                  <Form.Item label={i18n.t('account')} hasFeedback>
                    {getFieldDecorator('account', {
                      rules: [{ required: true, message: '登录账号不能为空' }],
                      initialValue: userDetail.accountName,
                    })(<Input type="text" disabled={disabled} />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                {type === 'create' && (
                  <Col span={12}>
                    <Form.Item
                      label="密码"
                      extra="请牢记随机密码，并将密码告知用户"
                    >
                      <Row gutter={8}>
                        <Col span={12}>
                          {getFieldDecorator('password', {
                            rules: [
                              { required: true, message: '密码不能为空' },
                            ],
                          })(<Input />)}
                        </Col>
                        <Col span={12}>
                          <Button onClick={this.handlePassword}>
                            生成随机密码
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                )}
                <Col span={12}>
                  <Form.Item label={i18n.t('status')}>
                    {getFieldDecorator('status', {
                      initialValue:
                        userDetail.status === undefined ? 1 : userDetail.status,
                    })(
                      <Radio.Group>
                        <Radio value={1}>启用</Radio>
                        <Radio value={0}>停用</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label={i18n.t('email')}>
                    {getFieldDecorator('email', {
                      initialValue: userDetail.email,
                    })(<Input />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col span={12}>
                  {/* 机构名称 */}
                  <Form.Item label={i18n.t('institutionName')} hasFeedback>
                    {getFieldDecorator('institution', {
                      rules: [{ required: true, message: '机构名称不能为空' }],
                      initialValue: userDetail.institutionIds
                        ? parseInt(userDetail.institutionIds)
                        : null,
                    })(
                      // 选择机构
                      <Select
                        placeholder={i18n.t('selectInstitution')}
                        showSearch
                        filterOption={(input, option) => {
                          return (
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          );
                        }}
                      >
                        {getInstitutionOptions(institutionData, 'id')}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 角色 */}
                  <Form.Item label={i18n.t('role')} hasFeedback>
                    {getFieldDecorator('role', {
                      rules: [{ required: true, message: '角色不能为空' }],
                      initialValue: userDetail.roleIds,
                    })(
                      <Select
                        placeholder={i18n.t('chooseRole')}
                        showSearch
                        filterOption={(input, option) => {
                          return (
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          );
                        }}
                      >
                        {roleInfoRecordList &&
                          roleInfoRecordList.map((item, index) => (
                            <Option key={item.id}>{item.roleName}</Option>
                          ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col span={12}>
                  {/* 用户类型 */}
                  <Form.Item label={i18n.t('userType')} hasFeedback>
                    {getFieldDecorator('type', {
                      initialValue: (userDetail.boxUserType || '') + '',
                      rules: [{ required: true, message: '用户类型不能为空' }],
                    })(
                      // 选择用户类型
                      <Select placeholder={i18n.t('chooseUserType')}>
                        {(userTypeList || []).map((item, index) => (
                          <Option key={item.id}>{item.userType}</Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 联系方式 */}
                  <Form.Item label="用户身份证号" hasFeedback>
                    {getFieldDecorator('certId', {
                      initialValue: userDetail.certId,
                    })(<Input type="text" />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col span={12}>
                  {/* 联系方式 */}
                  <Form.Item label={i18n.t('contactNo')} hasFeedback>
                    {getFieldDecorator('contact', {
                      initialValue: userDetail.mobile,
                    })(<Input type="text" />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col span={24}>
                  {/* 备注 */}
                  <Form.Item
                    label={i18n.t('remark')}
                    hasFeedback
                    {...formItemLayout1}
                  >
                    {getFieldDecorator('remark', {
                      initialValue: userDetail.remark,
                    })(<TextArea rows={4} autosize={false} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(Form.create()(UserAdd));
